export default class ISourceState {
  constructor() {
    this.list = [];
    this.details = {};
    this.status = 'uninitialized';
  }
}
